import { forwardRef } from 'react'

import { useDisconnectButton } from '@/src/hooks'
import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

/** @public */
export interface DisconnectButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  stopTracks?: boolean
}

/**
 * The `DisconnectButton` is a basic html button with the added ability to disconnect from a LiveKit room.
 * Normally this is the big red button that allows end users to leave the video or audio call.
 *
 * @example
 * ```tsx
 * <LiveKitRoom>
 *   <DisconnectButton>Leave room</DisconnectButton>
 * </LiveKitRoom>
 * ```
 * @public
 */
export const DisconnectButton = /* @__PURE__ */ forwardRef<
  HTMLButtonElement,
  DisconnectButtonProps
>(function DisconnectButton(props: DisconnectButtonProps, ref) {
  const { border_radius: borderRadius } = useAppSelector(selectBranding)
  const { buttonProps } = useDisconnectButton(props)

  return (
    <button
      ref={ref}
      disabled={buttonProps.disabled}
      className={buttonProps.className}
      style={{ borderRadius }}
    >
      {props.children}
    </button>
  )
})
